const emptyValue = {
    'value': '',
    'text': '',
}

module.exports = {
    emptyValue
};